const Accordion = (accordion) => {

	const toggleBtn = accordion.querySelector('.toggle-btn');
	if(toggleBtn) {
		toggleBtn.addEventListener('click', (e) => {
			e.preventDefault();
			accordion.setAttribute('data-revealed', accordion.getAttribute('data-revealed') !== 'true');
		});
	}
};

export default Accordion;